import { makeFailure, makeSuccess, TResult } from "./Result";


/**
 * Loads file from url
 * @param href 
 * @returns 
 */
export const loadFileUrl = async (href: string): Promise<TResult<Blob>> => {
    try {
        const response = await fetch(href);
        if (!response.ok) {
            throw Error("Failed to load file from url")
        };
        const data = await response.blob();
        return makeSuccess(data);
    } catch (error) {
        return makeFailure(error as Error);
    };
};

/**
 * Loads file from url and returns it base64 encoded
 * @param href 
 * @param filename 
 */
export const loadFileUrlToBase64data = async (href: string): Promise<TResult<string>> => {
    try {
        const blobData = await loadFileUrl(href);

        if (!blobData.isSuccess) {
            throw blobData.error
        };

        var reader = new FileReader();
        reader.readAsDataURL(blobData.value);

        const dataUrl = await new Promise(resolve => {
            reader.onloadend = () => resolve(reader.result)
        });

        if (typeof dataUrl !== "string") {
            throw Error("Failed to read file as data url");
        };

        const base64Data = dataUrl.split(',')[1];

        return makeSuccess(base64Data)
    } catch (error) {
        return makeFailure(error as Error)
    }
};

/**
 * Formats uknown string to file name safe format
 * @param text 
 * @returns 
 */
export const stringToFilename = (text: string): string => {
    return text.replace(/[^a-z0-9]/gi, '_').toLowerCase();
}